export default function wrapFirstNumber(value) {
    if (value !== '') {
        return `+49 (${value.charAt(0)})${value.slice(1)} - `;
    }
    return '';
}